import React from 'react'
import { useAppSelector } from '../../../hooks/redux'
import { type RootState } from '../../../store/store'
import { generateDefaultValueFormField } from '../../../functions/agent/AgentModals'
import { regExps } from '../../../constants'
import DefaultInput from '../../../app/custom/inputs/DefaultInput'
import CustomSelect from '../../../app/custom/selects/CustomSelect'
import GroupInput from '../../../app/custom/inputs/GroupInput'

export default function PropertyFieldsUnit({
    setValue,
    errors,
    register,
    control,
    unitID, objectID, modal
}: any): JSX.Element {
    const modalID = modal?.[0]?.id
    const units = useAppSelector((state: RootState) => state.units.units)
    const newPropertyFields = useAppSelector((state: RootState) => state.property.newPropertyFields)
    const config = useAppSelector((state: RootState) => state.app.config)
    const currentUnit = units?.filter((el: any) => el.id === Number(unitID))[0]
    const marketingData = currentUnit?.attributes?.Marketing
    const propertyData = currentUnit?.attributes?.Property?.data
    const isDisabled = false // modalID === "save_after_draft_agent_unit"
    const allAreas = config?.all.Area
        .filter((area: string) => area !== 'All areas')
        .sort((a: string, b: string) => a.localeCompare(b));


    const rowType = {
        id: 'Type',
        content: ['Property type', 'Select type'],
        selectors: ['Building', 'Community'],
        element: 'select', required: true,
        disabled: isDisabled,
        ...(generateDefaultValueFormField(propertyData?.attributes?.Type)),
    }


    const rowArea =
    {
        id: 'Area',
        content: ['Location', 'Select location'],
        selectors: allAreas, element: 'select',
        required: true,
        ...(generateDefaultValueFormField(newPropertyFields?.area ?? propertyData?.attributes?.Area ?? propertyData?.attributes?.Area))
    }
    const rowPropertyName = {
        id: 'Name', content: ['Property name', 'Input property name'], element: 'input', required: true,
        disabled: isDisabled, ...(generateDefaultValueFormField(newPropertyFields?.name || propertyData?.attributes?.Name)),
        ...(isDisabled ? {
            onInput: () => { setValue({ id: "Name", value: newPropertyFields?.name || propertyData?.attributes?.Name }) }
        } : {})
        , ...(isDisabled ? { value: newPropertyFields?.name || propertyData?.attributes?.Name } : {})
    }

    const rowPropertyLink =
        { id: 'GoogleMapsLink', content: ['Google Maps Link', 'Input goo.gl/maps link'], element: 'input', required: true, regexp: regExps.isGoogleMapsLink, ...(generateDefaultValueFormField(propertyData?.attributes?.GoogleMapsLink)) }

    const rowAreaSqFt = {
        id: 'AreaSqFt',
        content: ['Property area', 'Sq.Ft.', 'Input property area'],
        element: 'input-group',
        required: true,
        disabled: isDisabled,
        ...(generateDefaultValueFormField(currentUnit?.attributes?.SizeArea))
    }

    const rowMAKANI = {
        id: 'MAKANI',
        content: ['MAKANI', 'Input MAKANI'],
        element: 'input', required: false,
        ...(generateDefaultValueFormField(propertyData?.attributes?.MAKANI))
    }
    const rowDeveloper = {
        id: 'Developer',
        content: ['Property Developer',
            'Input Property Developer'],
        element: 'input',
        required: false,
        ...(generateDefaultValueFormField(propertyData?.attributes?.Developer))
    }
    const rowPlotNumber = {
        id: 'PlotNumber',
        content: ['Plot Number', 'Input Plot Number'],
        element: 'input',
        required: false,
        ...(generateDefaultValueFormField(propertyData?.attributes?.PlotNumber))
    }





    return (
        <>
            <div className="text-center py-4">
                <h1 className="text-dark m-0 fs-3">
                    Property details
                </h1>
            </div>
            <CustomSelect data={rowType} control={control} register={register} setValue={setValue} errors={errors} />
            <CustomSelect data={rowArea} control={control} register={register} setValue={setValue} errors={errors} />
            <DefaultInput row={rowPropertyName} register={register} errors={errors} setValue={setValue} />
            <DefaultInput row={rowPropertyLink} register={register} errors={errors} setValue={setValue} />
            <GroupInput row={rowAreaSqFt} register={register} errors={errors} setValue={setValue} />
            <DefaultInput row={rowMAKANI} register={register} errors={errors} setValue={setValue} />
            <DefaultInput row={rowDeveloper} register={register} errors={errors} setValue={setValue} />
            <DefaultInput row={rowPlotNumber} register={register} errors={errors} setValue={setValue} />
        </>
    )
}
